import { useMemo } from 'react';
import { getDataSource } from '@rsos/components/capstone/Location/helpers';
import { useCallByCallerID } from '@rsos/reduxDataStore/src/features/emergencyCalls';
import type {
  EmergencyCallLocation,
  EmergencyConversationLocation,
  EmergencyCallSecondaryLocation,
} from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCalls.types';
import { getMostRecentLocations } from '@rsos/utils/getMostRecentLoc';

/**
 * Hook to get all of the relevant details of a call.
 */
const useCallDetails = (callerID: string) => {
  const callDetails = useCallByCallerID(callerID);

  const { mostRecentLocation, mostRecentSecondaryLocation } =
    getMostRecentLocations(callDetails);

  const source = useMemo(
    () => getDataSource(mostRecentLocation || mostRecentSecondaryLocation),
    [mostRecentLocation, mostRecentSecondaryLocation],
  );

  const unifiedCallDetails = {
    callerID,
    isSecondaryLocation: !!mostRecentSecondaryLocation,
    lastLocation: mostRecentLocation || mostRecentSecondaryLocation,
    lastTimestamp: parseFloat(
      String(
        (mostRecentLocation as EmergencyCallLocation)?.location_time ??
          (mostRecentLocation as EmergencyConversationLocation)
            ?.conversation_start_time ??
          (mostRecentSecondaryLocation as EmergencyCallSecondaryLocation)
            ?.call_start_time ??
          mostRecentSecondaryLocation?.created_time ??
          '',
      ),
    ) as number | null,
    source,
    isAdmin: !!callDetails?.isAdmin,
    callStatus: callDetails?.callStatuses?.at(-1),
  };

  if (Number.isNaN(unifiedCallDetails.lastTimestamp)) {
    unifiedCallDetails.lastTimestamp = null;
  }

  return unifiedCallDetails;
};

export default useCallDetails;
